import React from "react";
import { Provider, connect } from "react-redux";
import { Route, Switch, useLocation } from "react-router-dom";
import { configureStore, getDefaultMiddleware } from "redux-starter-kit";
import reduxThunk from "redux-thunk";
import rootReducer from "../redux/reducers";
import * as actionCreators from "../redux/actions";
import Layout from "./Layout";
import logger from "redux-logger";
import Equipment from "../views/Equipment/Index.js";
import EquipmentDetails from "../views/Equipment/Details.js";

import NotFound from "../views/NotFound/Index.js";
import Login from "../views/Login/Index.js";
import Callback from "../views/Login/Callback";
import About from "../views/Contact/About";

import "antd/dist/antd.css";
import "./App.css";

const connectedEquipmentView = connect(
  state => ({
    redux: state.equipmentReducer,
    timestamp: new Date().toString()
  }),
  actionCreators
)(Equipment);

const connectedEquipmentDetailsView = connect(
  state => ({
    redux: state.equipmentReducer
  }),
  actionCreators
)(EquipmentDetails);

const connectedAbout = connect(
  state => ({
    redux: state.equipmentReducer
  }),
  actionCreators
)(About);

const connectedCallback = connect(
  state => ({
    redux: state.equipmentReducer
  }),
  actionCreators
)(Callback);

export const store = configureStore({
  reducer: rootReducer,
  // immutableStateInvariant, thunk, serializableStateInvariant logger
  middleware: [...getDefaultMiddleware(), reduxThunk]
  // middleware: [...getDefaultMiddleware(), reduxThunk]
});

const connectUser = connect(
  state => ({
    redux: state.equipmentReducer
  }),
  actionCreators
)(Layout);

const connectLogin = connect(
  state => ({
    redux: state.equipmentReducer
  }),
  actionCreators
)(Login);

const App = () => {
  let location = useLocation();

  return (
    <Provider store={store}>
      {/* On login screen there is no need have the side bar space */}
      <div className={location.pathname === "/login" ? "login" : "grid"}>
        <Route path="/" component={connectUser} />
        <div className="content">
          <Switch>
            <Route
              exact
              path="/implicit/callback"
              component={connectedCallback}
            />
            <Route exact path="/login" component={connectLogin} />
            <Route
              exact
              path="/(|equipment)"
              component={connectedEquipmentView}
            />
            <Route
              exact
              path="/equipment/:fleetNo/:branchID/:branchCode"
              component={connectedEquipmentDetailsView}
            />
            <Route exact path="/about" component={connectedAbout} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    </Provider>
  );
};

export default App;
